import * as React from 'react';
import classnames from 'classnames';
import kebabCase from 'lodash/kebabCase';

import ContentCardAsset from '../content-card/components/asset/ContentCardAsset';
import ContentCardDetails from '../content-card/components/details/ContentCardDetails';
import ContentCardStats from '../content-card/components/stats/ContentCardStats';

import { getCardType } from '../content-card/utils/content-card';

import './onsite-content-card.scss';

import type { ChannelTypes, InfluencerCommon } from 'types';
import type {
  ContentCardCreatorProfile,
  ContentCardItem
} from 'components/cards/content-card/types';
import { ReportingMetaInfoIGStorySnippetType } from 'modules/reporting/types';

const onsiteIgStorySnippetType = 'total_of_snippets';

type Props = {
  item: ContentCardItem,
  index: number,
  channel: ChannelTypes,
  creatorProfile: InfluencerCommon | Partial<ContentCardCreatorProfile>,
  suppressBoxShadow?: boolean,
  igStorySnippetType?: ReportingMetaInfoIGStorySnippetType,
  onNoPostClick?: () => void
};

const OnsiteContentCard = ({
  item,
  index,
  channel,
  creatorProfile,
  suppressBoxShadow,
  igStorySnippetType,
  onNoPostClick
}: Props): JSX.Element => {
  const containerClasses = classnames('onsite-content-card', {
    'onsite-content-card--no-box-shadow': Boolean(suppressBoxShadow),
    [`onsite-content-card--is-${kebabCase(item.type)}`]: Boolean(item.type)
  });

  const cardType = getCardType(item.type);

  return (
    <div className={containerClasses}>
      <ContentCardAsset
        item={item}
        index={index}
        channel={channel}
        toggleStats
        onNoPostClick={onNoPostClick}
      />
      <ContentCardStats
        item={item}
        toggleStats
        hideIcon
        position="static"
        igStorySnippetType={igStorySnippetType || onsiteIgStorySnippetType}
      />
      <ContentCardDetails
        item={item}
        cardType={cardType}
        creatorProfile={creatorProfile}
        igStorySnippetType={igStorySnippetType || onsiteIgStorySnippetType}
        channel={channel}
      />
    </div>
  );
};

export default OnsiteContentCard;
